import { EventEmitter, Injectable } from '@angular/core';
import { ClientBookingSlot } from '@app/features-modules/client/appoinment-form/meeting-mode/meeting-mode.component';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: "root"
})
export class CommonService {
  private subject = new Subject<any>();

  isComponent=""
  assignAccountant=[]
  uploadedFileName = '';
  meetingType : any;
  note : any;
  otherConsultation : any;
  userCaseId : any;
  fileData : any;
  radioSelectedValue : any;

  public changePasswordEvent: EventEmitter<boolean> = new EventEmitter();

  public clientBookingSlotEvent: EventEmitter<ClientBookingSlot> = new EventEmitter();

  sendSetLanguageEvent() {
    this.subject.next();

  }
  getSetLanguageEvent():Observable<any>{
    return this.subject.asObservable();
  }
}
